"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Sidebar/List/ResultsStatus.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _ListResultsStatus = require('web/components/ListResultsStatus'); var _ListResultsStatus2 = _interopRequireDefault(_ListResultsStatus);
var _icons = require('web/screens/Search/Refined/icons');










/* The list's spinner, and what a search that finds nothing says: the inbox's
 * empty block, with the way out of it. */
const ResultsStatus = ({
  noun, searchQuery, isLoading, resultsCount, onClearSearch,
}) => {
  if (isLoading || resultsCount || !searchQuery.trim()) {
    return (
      _react2.default.createElement(_ListResultsStatus2.default, {
        isLoading: isLoading,
        resultsCount: resultsCount,
        noResultsLabel: `No ${noun} found.`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
      )
    )
  }

  return (
    _react2.default.createElement('div', { className: "inbox-empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
      , _react2.default.createElement('div', { className: "inbox-empty--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}, _react2.default.createElement(_icons.SearchIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}} ))
      , _react2.default.createElement('div', { className: "inbox-empty--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}, "No " ,  noun , " found" )
      , _react2.default.createElement('p', { className: "inbox-empty--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
        ,  `Nothing matches \u201C${searchQuery}\u201D. Check the spelling, or try another name.` 
      )
      , _react2.default.createElement('div', { className: "inbox-empty--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
        , _react2.default.createElement('button', { type: "button", className: "inbox-empty--btn", onClick: onClearSearch, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}, "Clear search" )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, ResultsStatus)
